import { createTheme } from "@mui/material";

export const mainTheme = createTheme({
  typography: {
    fontFamily: ['"Space Mono"', "monospace"].join(","),
    button: {
      fontWeight: 700,
    },
    // custom variants
    directions: {
      fontSize: "1.8rem",
      fontWeight: "normal",
    },
    mobileDirections: {
      fontSize: "1.3rem",
      fontWeight: "normal",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        disableElevation: true,
      },
      styleOverrides: {
        fontWeight: 700,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          borderRadius: "1.2rem",
          color: "#000",
        },
        input: {
          padding: "0.45rem 1.5rem",
          width: "17rem",
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          marginRight: 0,
        },
      },
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          width: "40px",
          height: "40px",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          transition: "none",
          "&:hover": {
            backgroundColor: "#090c9b",
          },
        },
      },
    },
  },
  palette: {
    darkBluePrimary: {
      main: "#090c9b",
      contrastText: "#fff",
    },
    darkPinkPrimary: {
      main: "#a20054",
      dark: "#75003d",
    },
    darkPurplePrimary: {
      main: "#4d089a",
      contrastText: "#fff",
    },
    darkGrayPrimary: {
      main: "#505050",
      contrastText: "#fff",
    },
    lightGrayPrimary: {
      main: "#888",
      contrastText: "#000",
    },
    greenPrimary: {
      main: "#218246",
      contrastText: "#fff",
    },
    orangePrimary: {
      main: "#FF7B29",
      contrastText: "#fff",
    },
    redPrimary: {
      main: "#FF1616",
      contrastText: "#fff",
    },
    blackPrimary: {
      main: "#000",
      contrastText: "#fff",
    },
    whitePrimary: {
      main: "#fff",
      contrastText: "#000",
    },
    darkGraySecondary: {
      main: "#474646",
      contrastText: "#fff",
    },
    lightGraySecondary: {
      main: "rgba(211,211,211,0.8)",
      contrastText: "#000",
    },
    blackSecondary: {
      main: "#131313",
      contrastText: "#fff",
    },
    background: {
      default: "#000",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(211,211,211,0.8)",
    },
    action: {
      disabled: "rgba(211, 211, 211, 0.8)",
    },
  },
});

export const generatedImageTheme = createTheme({
  typography: {
    fontFamily: ['"Space Mono"', "monospace"].join(","),
  },
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "20px",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
  },
  palette: {
    goldPrimary: "#F4C01E",
    whitePrimary: mainTheme.palette.whitePrimary.main,
    blackPrimary: mainTheme.palette.blackPrimary.main,
  },
});
